module.exports = __webpack_public_path__ + "static/media/tfs-logo.135cab8b.png";